import { appConfig } from 'appConfig';

const apiEndpoint = `${appConfig.baseUrl}/v1/`;

export const appConstantUrl = {
  customerUrl: `${apiEndpoint}customer`,
  euSubmitUrl: `${apiEndpoint}FEDSAEUDDSInfoSubmit`,
  fileUploadUrl: `${apiEndpoint}supplierfileupload`,
  manualSubmitUrl: `${apiEndpoint}SupplierInputDDSInfo`,
  validateDdsUrl: `${apiEndpoint}ValidateDDS`,
  masterDataUrl: `${apiEndpoint}MasterData`,
  ddsInfoUrl: `${apiEndpoint}ddsinfo`,
  riskDetailUrl: `${apiEndpoint}riskdetail`,
  pdfDownloadUrl: `${apiEndpoint}FEDSAPDFDetails`,
  excelDownloadUrl: `${apiEndpoint}GLAResult`,
  changeStatusUrl: `${apiEndpoint}FEDSAUpdateStatus`,
  euFileUpload: `${apiEndpoint}fedsasupplierfileupload`,
  fedsaDdsInfo: `${apiEndpoint}fedsaddsinfo?Category`,
  pdfDownloadUrlEuSupplier: `${apiEndpoint}fedsaddspdfdetails`,
};
